<microsec-card [isBordered]="true">
  <div class="flex flex-col gap-4 w-full">
    <div class="font-bold text-xl">Update Analyzer Rules</div>
    <div class="text-gray-500">
      <span>MicroIDS updates it analyzers with rules from TIP automatically every {{ tipConfig()?.download_frequency }} hour(s).&nbsp;</span>
      <span>You can also click on the Update button below to manually update the analyzers.</span>
    </div>
    <div class="flex border-y border-b-1 border-grey -mx-5 bg-grey">
      <div class="flex flex-row p-5 gap-12 items-center">
        <div class="flex items-center">
          <div class="mr-2 font-bold">Status:</div>
          <div class="flex items-center gap-2 text-value">
            @switch (tipConfig()?.status) {
              @case (STATUSES.STARTING_SOON) {
                <div class="flex items-center gap-2 status-color-orange">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  <span>Starting soon</span>
                </div>
              }
              @case (STATUSES.IN_PROGRESS) {
                <div class="flex items-center gap-2 status-color-grey">
                  <i class="fa-regular fa-circle"></i>
                  <span>In progress...</span>
                </div>
              }
              @case (STATUSES.SUCCESS) {
                <div class="flex items-center gap-2 status-color-green">
                  <i class="fa fa-circle-check"></i>
                  <span>Up to date</span>
                </div>
              }
              @case (STATUSES.FAIL) {
                <div class="flex items-center gap-2 status-color-red">
                  <i class="fa fa-circle-exclamation"></i>
                  <span>Failed</span>
                </div>
              }
              @default {
                <div class="flex items-center gap-2 status-color-default">
                  <span>-</span>
                </div>
              }
            }
          </div>
        </div>
        <div class="flex items-center">
          <div class="mr-2 font-bold">Last Updated:</div>
          <div class="text-value">{{ lastUpdated()?.format(MOMENT_DATETIME) || '-' }}</div>
        </div>
        <div class="flex items-center">
          <div class="mr-2 font-bold">Next Update:</div>
          <div class="text-value">{{ nextUpdate()?.format(MOMENT_DATETIME) || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="flex gap-2">
      <p-button
        severity="primary"
        [pTooltip]="updateButtonMessage()"
        tooltipPosition="bottom"
        appendTo="body"
        label="Update"
        (onClick)="updateAnalyzerRules()"
        [disabled]="!!isLoading() || tipConfig()?.status === STATUSES.STARTING_SOON || tipConfig()?.status === STATUSES.IN_PROGRESS" />
    </div>
  </div>
</microsec-card>
